import { makeAutoObservable } from 'mobx';
import { ProjectReportInterface, TasksReportInterface } from '../../interfaces/ReportInterface';
import { rootStore } from '../rootStore';
import { ReportFilterInterface } from '../../interfaces/TimeTrackingInterface';
import { RawTimeTrackingDataInterface } from '../interfaces/task';

export class ReportStore {
  loading: boolean = false;
  projectReportData: ProjectReportInterface[] = [];
  filteredTaskReportData: TasksReportInterface[] = [];
  reportFilter: ReportFilterInterface = {
    selectedDataType: 1,
    timeViewType: 1,
    chartType: 1
  };
  timeTrackingReportData: RawTimeTrackingDataInterface[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  get taskReportData(): TasksReportInterface[] {
    return rootStore.taskStore.tasks?.map((task) => ({
      id: task.id,
      projectId: task.project?.id || '',
      users: task.users,
      status: task.status,
      projectName: task.project?.name || '',
      name: task.name,
      dueDate: task.dueDate ?? null
    }));
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  //Project Report Variables
  setProjectReportData(projectReportData: ProjectReportInterface[]) {
    this.projectReportData = projectReportData;
  }

  setUserExist(projectId: string, userExist: boolean) {
    const projectIndex = this.projectReportData.findIndex((project) => project.id === projectId);
    if (projectIndex !== -1) {
      this.projectReportData[projectIndex].isUserExist = userExist;
    }
  }

  //Task Report Variables
  setFilteredTaskReportData(filteredTaskReportData: TasksReportInterface[]) {
    this.filteredTaskReportData = filteredTaskReportData;
  }

  //Time Report Variables
  setTimeTrackingReportData(timeTrackingReportData: RawTimeTrackingDataInterface[]) {
    this.timeTrackingReportData = timeTrackingReportData;
  }

  updateReportFilter(propsName: string, value: number) {
    this.reportFilter[propsName as keyof ReportFilterInterface] = value;
  }

  // Clear report related data
  clearReportData() {
    this.loading = false;
    this.projectReportData = [];
    this.filteredTaskReportData = [];
    this.timeTrackingReportData = [];
  }
}
